<template>
  <div>
    <button class="toggle-button" @click="toggleChatbot">
      <img alt="chat-icon" src="./chat-ico.png" />
      <h4 class="mb-0 d-none d-lg-inline-block">Chat With SPENDiD</h4>
    </button>
    <div class="chatbot-container card" v-if="showChatbot">
      <div class="chatbot">
        <div class="chat-bot-title">
          <h2>Chat Assistant Beta</h2>
          <div>
            <button
              @click="toggleChatbot"
              class="minus-button btn btn-primary btn-sm mx-2"
            >
              <i class="fa fa-minus text-light"></i>
            </button>
            <button
              @click="handleclearChat"
              class="close-button btn btn-danger btn-sm"
            >
              <i class="fa fa-times text-light"></i>
            </button>
          </div>
        </div>

        <div class="chat-container">
          <div class="chat-messages" ref="chatMessages">
            <div v-for="(message, index) in reversedMessages" :key="index" :class="{
                'user-message': message.type === 'user',
                'bot-message': message.type === 'bot',
              }">
                <div v-if="message.type === 'bot'" class="d-flex">
                  <img src="./chat-ico.png" class="icon-bot flex-shrink-0" />
                  <div class="message">{{ message.text }}</div>
                </div>
                <div v-else-if="message.type === 'user'">{{ message.text }}</div>
                <div v-else class="error-message">
                  <i class="fa fa-exclamation-circle icon-error"></i>
                  {{ message.text }}
                </div>
            </div>
            <div v-if="loading" class="loading-indicator">
              <img src="./Fountain.gif" />
            </div>
          </div>
          <div class="notemsg">
            <p>Our bot usually takes time 10-15 sec to respond.</p>
          </div>
          <div class="placeholder-area">
            <input
              class="input-textarea"
              v-model="inputMessage"
              @keyup.enter="sendMessage"
              placeholder="Type your message..."
            />
            <!-- <textarea
              class="input-textarea"
              v-model="inputMessage"
              @keyup.enter="sendMessage"
              placeholder="Type your message..."
            ></textarea> -->

            <button @click="sendMessage" class="send-button btn btn-sm">
              <i class="fa fa-paper-plane"></i>
            </button>
          </div>
          <!-- Inactivity message -->
          <div v-if="showInactivityMessage" class="inactivity-message">
            <p>You have been inactive. Do you want to continue the chat?</p>
            <button @click="closeChat" class="btn btn-close">Close</button>
            <button @click="continueChat" class="btn btn-continue">
              Continue
            </button>
          </div>
          <div v-if="showclosechat" class="inactivity-message">
            <p>Do you want to continue the chat?</p>
            <button @click="closeChat" class="btn btn-close">Close</button>
            <button @click="continueChat" class="btn btn-continue">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uuid } from "vue-uuid";

export default {
  data() {
    return {
      messages: localStorage.getItem("userchat")
        ? JSON.parse(localStorage.getItem("userchat"))
        : [
            {
              text: "Hi! How can I assist you?",
              type: "bot",
            },
          ],
      inputMessage: "",
      showChatbot: false,
      loading: false,
      error: null,
      userId: null,
      inactivityTimeout: null,
      showInactivityMessage: false,
      showclosechat: false,
    };
  },
  mounted() {
    this.handleNewUser();
  },
  computed: {
    reversedMessages() {
      // Reverse the order of messages
      return this.messages.slice().reverse();
    },
  },
  methods: {
    handleNewUser() {
      // eslint-disable-next-line no-console
      //console.log("created >>>", localStorage.getItem("user_id"));
      // Try to retrieve the user ID from local storage
      this.userId = localStorage.getItem("user_id")
        ? localStorage.getItem("user_id")
        : null;

      // If it doesn't exist, generate a new user ID and store it
      if (!this.userId) {
        this.userId = uuid.v4();
        localStorage.setItem("user_id", this.userId);
      }
      // eslint-disable-next-line no-console
      //console.log("uuids >>>", this.userId);
    },

    toggleChatbot() {
      this.showChatbot = !this.showChatbot;
    },

    handleclearChat() {
      this.showclosechat = true;
      this.showInactivityMessage = false;
      // localStorage.removeItem("user_id");
      // localStorage.removeItem("userchat");
      // this.messages = [
      //   [
      //     {
      //       text: "Hi! How can I assist you?",
      //       type: "bot"
      //     }
      //   ]
      // ];
      // this.handleCloseChat();
    },

    closeChat() {
      // Handle "Close" action, e.g., hide the chatbot and clear the inactivity message
      this.showChatbot = false;
      this.showclosechat = false;
      this.showInactivityMessage = false;
      localStorage.removeItem("user_id");
      localStorage.removeItem("userchat");
      this.messages = [
        {
          text: "Hi! How can I assist you?",
          type: "bot",
        },
      ];
      this.handleCloseChat();
      this.handleNewUser();
    },

    handleCloseChat() {
      const formData = new FormData();
      formData.append("session_id", this.userId);
      this.$http
        .post("https://editor.creativebuffer.com/clear/", formData)
        .then((response) => {
          // eslint-disable-next-line no-console
          console.log(response);
        });
    },

    continueChat() {
      // Handle "Continue" action, e.g., remove the inactivity message and reset the timeout
      this.showInactivityMessage = false;
      this.showclosechat = false;
      this.startInactivityTimeout();
    },
    startInactivityTimeout() {
      this.clearInactivityTimeout();
      this.inactivityTimeout = setTimeout(() => {
        // Show the inactivity message after 2 minutes of inactivity
        this.showInactivityMessage = true;
      }, 120000); // 2 minutes
    },
    clearInactivityTimeout() {
      clearTimeout(this.inactivityTimeout);
    },

    handleUserChatObj(msgObj) {
      const msguserObj = localStorage.getItem("userchat")
        ? localStorage.getItem("userchat")
        : null;
      // eslint-disable-next-line no-console
      //console.log("msguserObj >>>", msguserObj);
      if (!msguserObj) {
        // eslint-disable-next-line no-console
        //console.log("msgObj >>>", msgObj);
        localStorage.setItem("userchat", JSON.stringify([msgObj]));
      } else {
        const paredObj = JSON.parse(msguserObj);
        const prseObj = [...paredObj, msgObj];
        //const tempObj = prseObj.push(msgObj);
        // eslint-disable-next-line no-console
        //console.log("prseObj >>>", prseObj);

        localStorage.setItem("userchat", JSON.stringify(prseObj));
      }
    },

    sendMessage() {
      if (this.inputMessage.trim() === "") return;

      this.messages.push({
        text: this.inputMessage,
        type: "user",
      });

      this.handleUserChatObj({
        text: this.inputMessage,
        type: "user",
      });
      // Simulate a response from the chatbot
      const formData = new FormData();
      formData.append("question", this.inputMessage);
      formData.append("session_id", this.userId);
      // formDatas.append("text", text);
      // const result = await this.$http.post(
      //   "https://editor.creativebuffer.com/get_response/",
      //   formDatas
      // );
      // const msgAi = result.data.data;

      this.loading = true; // Set loading to true while waiting for the API response

      this.$http
        .post("https://editor.creativebuffer.com/ask/", formData)
        .then((response) => {
          this.messages.push({
            text: response.data.response,
            type: "bot",
          });
          this.handleUserChatObj({
            text: response.data.response,
            type: "bot",
          });
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          //console.log("error >>>", error.response.data.response);
          this.error = error.messages;
          this.messages.push({
            text: error.response.data.response, // "An error occurred while processing your request.",
            type: "error",
          });
          this.handleUserChatObj({
            text: error.response.data.response, // "An error occurred while processing your request.",
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false; // Set loading back to false once the API response is received
        });

      //localStorage.setItem("userchat", JSON.stringify(this.messages));
      // const msguserObj = localStorage.getItem("userchat")
      //   ? localStorage.getItem("userchat")
      //   : null;

      // if (!msguserObj) {
      //   localStorage.setItem("userchat", JSON.stringify(this.messages));
      // } else {
      //   // eslint-disable-next-line no-console
      //   console.log("msguserObj >>>", msguserObj);
      //   localStorage.setItem("userchat", JSON.stringify(this.messages));
      // }

      this.inputMessage = "";
      // Reset the inactivity timeout on user activity
      this.clearInactivityTimeout();
      this.startInactivityTimeout();

    },
    
  },
};
</script>

<style scoped>
.inactivity-message {
  position: absolute;
  width: 97%;
  bottom: 0;
  background-color: #ffdddd;
  padding: 10px;
  text-align: center;
  border: 1px solid #ff6666;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 6px;
  border-radius: 10px;
}

.inactivity-message button {
  margin: 5px;
  padding: 5px 10px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
}
.inactivity-message .btn-continue {
  border: 1px solid #27a79b;
  background-color: #cee7e5;
  color: #27a79b;
}
.inactivity-message .btn-close {
  border: 1px solid #ff6666;
  background-color: #f9d1d1;
  color: #ff6666;
}
.inactivity-message p {
  font-size: 18px;
  font-weight: 600;
  color: #180f4f;
}
.minus-button {
  background-color: #1d2240 !important;
  border-color: #1d2240 !important;
}
.minus-button:hover,
.minus-button:focus,
.minus-button:active {
  background-color: #1d2240 !important;
  border-color: #1d2240 !important;
}
.send-button {
  position: absolute;
  right: 10px;
  background-color: #27a79b;
}
.send-button i {
  color: #fff;
}
.loading-indicator {
  text-align: center;
  padding: 10px;
}
.loading-indicator{
  position: absolute;
  bottom: -13px;
  left: 0;
  right: 0;
}
.chatbot-container {
  position: fixed;
  width: 470px;
  height: 510px;
  z-index: 99999;
  bottom: 10px;
  left: 10px;
  border: none;
  border-radius: 10px;
}
.message {
  display: flex;
  align-items: flex-start;
  padding: 10px 20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 0px;
  background-color: #f3f1ff;
  color: #180f4f;
  /* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */
  /* margin: 5px 0; */
}
.darkmode .message {
  background-color: #505c7b;
  color: #fcfcff;
}
.error-message {
  display: flex;
  align-items: center;
  margin: 5px 0;
  text-align: left;
  /* background-color: #eee; */
  color: #333;
  padding: 5px 10px;
  border-radius: 5px;
  margin: 5px 0;
}

.icon-error {
  font-size: 24px;
  margin-right: 10px;
  color: #ff5733; /* Error icon color */
}

.icon-bot {
  width: 50px;
  height: 50px;
  margin-right: 5px;
  padding: 2px;
}

.toggle-button {
  /* position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9; */
  padding: 6px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  /* width: 60px;
  height: 60px;
  display: flex;
  display: -webkit-flex; */
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
}
.toggle-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  /* background-color: #1d2240;
  color: #1d2240; */
}
/* .darkmode .toggle-button {
  background-color: #1d2240;
  color: #fff;
} */
.toggle-button img {
  max-width: 32px;
  /* margin: auto; */
}
@media screen and (max-width: 991px) {
  .toggle-button img {
    max-width: 26px;
}
}
.chatbot {
  position: absolute;
  bottom: 0;
  right: 0;
  top: 0;
  left: 0;
  /* border: 1px solid #ccc; */
  border-radius: 10px;
  background: #fff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  z-index: 998;
}
.darkmode .chatbot {
  /* border: 1px solid #878c9a; */
  background: #292f45;
}
.chat-bot-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px;
  background: #27a79b;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.chat-bot-title h2 {
  font-size: 20px;
  color: #fff;
  margin: 0;
}
@media screen and (max-width: 545px) {
  .chat-bot-title h2 {
    font-size: 16px;
  }
}
.chat-bot-title .btn {
  border-radius: 100px !important;
  width: 30px;
  height: 30px;
  padding: 0 !important;
}
@media screen and (max-width: 545px) {
  .chat-bot-title .btn {
    width: 24px;
    height: 24px;
  }
}
.chat-container {
  position: absolute;
  top: 55px;
  left: 0;
  bottom: 0;
  right: 0;
}
.chat-messages {
  padding: 15px;
  top: 0;
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  display: flex;
  height: 380px;
  overflow-y: auto;
  flex-direction: column-reverse; /* Reverse the order of messag
  
  overflow-y: auto; /* Enable vertical scrolling */
}
@media screen and (max-width: 545px) {
  .chat-messages {
    padding: 10px;
  }
}
.placeholder-area {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  display: flex;
  align-items: center;
}

.notemsg {
  position: absolute;
  bottom: 50px;
  font-size: 12px;
  left: 0;
  right: 0;
  width: 100%;
  text-align: center;
  color: #151d32;
  background-color: #fff;
}
.darkmode .notemsg {
  background-color: #151d32;
  border-top: solid 1px #1d2240;
  border-bottom: solid 1px #1d2240;
  color: #fff;
}

.notemsg p {
  margin: 0;
}
.darkmode .notemsg p {
  color: #b7b9c3;
}

.user-message {
  display: flex;
  justify-content: flex-end;
}
.user-message > div {
  text-align: right;
  /* width: 100%;
  max-width: 330px; */
  background-color: #8ab200;
  /* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */
  max-width: 330px;
  color: #fff;
  padding: 10px 20px;
  margin: 5px 0 5px auto;
}
.user-message > div {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 10px;
}
.bot-message {
  text-align: left;
  /* background-color: #eee; */
  color: #333;
  padding: 10px;
  border-radius: 5px;
  margin: 15px 0;
  width: 100%;
  max-width: 330px;
}
@media screen and (max-width: 545px) {
  .bot-message {
    padding: 0px;
  }
}
.input-textarea {
  width: 100%;
  padding: 10px;
  border: none;
  background-color: #fff;
  border-top: 1px solid #ccc;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  height: 50px;
  padding-right: 60px;
  font-weight: 500 !important;
  word-wrap: break-word !important; /* Allow long words to wrap to the next line */
  white-space: pre-line !important;
}
@media screen and (max-width: 545px) {
  .input-textarea {
    font-size: 14px;
  }
}
.darkmode .input-textarea,
.darkmode .input-textarea:focus {
  color: #fff;
  background-color: #43495a;
  border-top: solid 1px #596179 !important;
}
.darkmode .input-textarea::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1; /* Firefox */
}
@media screen and (max-width: 545px) {
  .chatbot-container {
    width: 90%;
    height: 400px;
    bottom: 28px;
    right: 0;
    left: 0;
    margin: 0 auto;
  }
  /* .toggle-button {
    width: 40px;
    height: 40px;
    bottom: 40px;
    right: 10px;
  }
  .toggle-button img {
    max-width: 34px;
  } */
  .bot-message {
    max-width: 87%;
  }
  .message,
  .user-message {
    font-size: 0.9rem;
  }
}
</style>
